import {Conversation} from '@stripe-internal/conversations-client';

import {AssistantLogContent} from '../../../core/components/AssistantLog';
import {useThreadsConversationLogEvents} from '../../hooks/useThreadsConversationLogEvents';

type Props = {
  conversation?: Conversation | null;
};

function ThreadsActiveConversationLog({
  conversation,
}: {
  conversation: Conversation;
}) {
  useThreadsConversationLogEvents(conversation);

  return <AssistantLogContent conversation={conversation} />;
}

export function ThreadsConversationLog({conversation}: Props) {
  if (!conversation) {
    return null;
  }

  return <ThreadsActiveConversationLog conversation={conversation} />;
}
